import { makeStyles } from '@admitkard/ccl';
import { WebStoryCard } from 'components/Blog/WebStoryCard';
import React, { FunctionComponent, useState } from 'react';
const useStyles = makeStyles(
  () => ({
    root: {
      width: '100%',
      fontFamily: 'Poppins',
    },
    carousel: {
      marginLeft: '1rem',
      '@media screen and (min-width: 992px)': {
        marginLeft: '0rem',
      },
      height: '26.4375rem',
      display: 'flex',
      overflow: 'hidden',
      position: 'relative',
    },
    handleContainerLeft: {
      display: 'none',
      '@media screen and (min-width: 1200px)': {
        display: 'flex',
        justifyContent: 'left',
        overflow: 'hidden',
        height: '100%',
        position: 'absolute',
        left: 0,
        background: 'linear-gradient(to right, rgba(256,256,256,0), rgba(256,256,256,0.5))',
      },
    },
    handleContainerRight: {
      display: 'none',
      '@media screen and (min-width: 1200px)': {
        display: 'flex',
        justifyContent: 'right',
        overflow: 'hidden',
        height: '100%',
        position: 'absolute',
        right: 0,
        background: 'linear-gradient(to right, rgba(256,256,256,0), rgba(256,256,256,0.5))',
      },
    },
    handle: {
      border: 'none',
      borderRadius: '1rem',
      flexGrow: 0,
      flexShrink: 0,
      backgroundColor: 'transparent',
      zIndex: 10,
      width: '5rem',
      fontSize: '5rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#483287',
      lineHeight: 0,
      transition: 'background-color 150ms ease-in-out',
      '&:hover &:focus': {
        backgroundColor: 'rgba(255, 255, 255, .5)',
      },
    },
    handleBox: {
      height: '4rem',
      display: 'flex',
      placeContent: 'center',
      aspectRatio: '1/1',
      borderRadius: '1.25rem',
      border: 'none',
      fontSize: '3rem',
      cursor:'pointer',
      '&:disabled':{
        cursor: 'initial',
      }
    },
    leftHandle: {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      marginLeft: '-0.5rem',
    },
    rightHandle: {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      marginRight: '-0.5rem',
    },
    carouselContent: {
      overflowX: 'auto',
      marginRight: '1rem',
      borderRadius: '1.75rem',
      '@media screen and (min-width: 1200px)': {
        marginRight: '5rem',
        marginLeft:'5rem',
      },
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    cardContainer: {
      display: 'flex',
      gap: '1rem',
      width: 'max-content',
    },
    card: {
      position: 'relative',
      width: '16.66rem',
      height: '25rem',
      padding: '0.25rem',
      display: 'flex',
      borderRadius: '1.75rem',
      '-webkit-border-radius': '1.75rem',
      overflow: 'hidden',
      '-webkit-mask-image': '-webkit-radial-gradient(white, black)',
      '&:last-child': {
        width: '.825rem',
      },
      '@media screen and (min-width: 992px)': {
        width: '20rem',
        height: '30rem',
      },
      '@media screen and (min-width: 400px)': {
        '&:last-child': {
          display: 'none',
        },
      },
    },
    cardBackground: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      right: 0,
      bottom: 0,
      minWidth: '100%',
      minHeight: '100%',
      '& video': {
        objectFit: 'cover',
        width: 'inherit',
      },
    },
    playButton: {
      position: 'absolute',
      width: 'inherit',
      height: 'inherit',
      display: 'grid',
      placeItems: 'center',
    },
    button: {
      color: '#F7EFFF',
      boxSizing: 'border-box',
      border: 'none',
      display: 'grid',
      placeItems: 'center',
      width: '3.2rem',
      height: '3.2rem',
      borderRadius: '50%',
      transition: 'all 0.3s ease',
      '& svg': {
        marginLeft: '0.1rem',
      },
    },
    infoContainer: {
      zIndex: 10,
      width: '100%',
      height: 'auto',
      display: 'flex',
      flexDirection: 'column',
      borderRadius: '1.5rem',
      backgroundColor: '#FFFFFF',
      alignSelf: 'end',
      opacity: '1',
      transition: 'all 0.5s linear',
    },
    testimony: {
      fontSize: '0.8rem',
      lineHeight: '1.2rem',
      color: '#483287',
      margin: '0.9rem',
      maxHeight: '4.65rem',
      '-webkit-line-clamp': '4',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '@media screen and (min-width: 992px)': {
        fontSize: '0.95rem',
        lineHeight: '1.4rem',
        margin: '1rem',
        maxHeight: '5.65rem',
      },
    },
    divider: {
      width: '100%',
      height: '0rem',
      border: '1px solid #A259FF',
    },
    info: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '3rem',
      '@media screen and (min-width: 992px)': {
        height: '4rem',
      },
    },
    name: {
      margin: '1.5rem',
      color: '#483287',
      fontSize: '0.75rem',
      '@media screen and (min-width: 992px)': {
        fontSize: '0.875rem',
      },
    },
    universityLogo: {
      height: '2rem',
      marginRight: '0.5rem'
    },
  }),
  { name: 'LatestStories' }
);
const LatestStories: FunctionComponent<any> = (props) => {
  const classes = useStyles();

  const [disableLeft, setDisableLeft] = useState(true);
  const [disableRight, setDisableRight] = useState(false);

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const target = event.target as HTMLDivElement;
    if (target.scrollLeft === 0) {
      setDisableLeft(true);
    } else {
      setDisableLeft(false);
    }
    if (target.scrollWidth - target.clientWidth === target.scrollLeft) {
      setDisableRight(true);
    } else {
      setDisableRight(false);
    }
  };


  const [scrollToPosition,setScrollToPosition] = useState(0);

  function scrollIntoViewLeft(): void {
    const carousel = document.getElementById('carousel');
    const element = document.getElementById('web-story-card');
    if (element) {
      setScrollToPosition(scrollToPosition + element?.offsetWidth + 16);
      carousel?.scroll(scrollToPosition + element?.offsetWidth + 16, 0);
    }
  }
  function scrollIntoViewRight(): void {
    const carousel = document.getElementById('carousel');
    const element = document.getElementById('web-story-card');
    if (element) {
      setScrollToPosition(scrollToPosition - element.offsetWidth - 16);
      carousel?.scrollTo(scrollToPosition - element.offsetWidth - 16, 0);
    }
  }

  return (
    <>
      <div className={classes.root}>
        <div className={classes.carousel}>
          <div className={classes.handleContainerLeft}>
            <div className={`${classes.handle} ${classes.leftHandle}`}>
              <button className={classes.handleBox} onClick={scrollIntoViewRight} disabled={disableLeft}>
                <div>&#8249;</div>
              </button>
            </div>
          </div>
          <div className={classes.carouselContent} id="carousel"  onScroll={handleScroll}>
            <div className={classes.cardContainer}>
              {props.webStories?.slice(0,10).map((webStory:any)=>
                <WebStoryCard
                  key={webStory.id}
                  featuredImage={webStory.featuredImage?.node?.sourceUrl}
                  title={webStory.title}
                  authorName={webStory.author?.node?.name}
                  date={webStory.date}
                  slug={webStory.slug}
                />
              )}
            </div>
          </div>
          <div className={classes.handleContainerRight}>
            <div className={`${classes.handle} ${classes.rightHandle}`}>
              <button className={classes.handleBox} onClick={scrollIntoViewLeft} disabled={disableRight}>
                <div>&#8250;</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LatestStories;
